<template>
  <b-container fluid>
    <form @submit.prevent="saveData">
      <b-row>
        <b-col sm="12">
          <card>
            <template v-slot:headerTitle>
              <h4 class="card-title"><b>Abrir Ticket</b></h4>
            </template>
            <div class="row px-5 mt-3">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="asunto" class="form-label">Asunto</label>
                  <input required v-model="item.General.Asunto" placeholder="Escriba el Asunto..." type="text"
                    class="form-control" id="asunto" />
                </div>
              </div>
              <div class="col-md-3">
                <div class="mb-3">
                  <label for="departamento" class="form-label">Departamento</label>
                  <b-form-select id="departamento" :options="listaDepartamentos" required
                    v-model="item.General.DepartamentoId" value-field="id" text-field="descripcion">
                    <template #first>
                      <b-form-select-option :value="null" disabled>-- Seleccione --</b-form-select-option>
                    </template>
                  </b-form-select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="mb-3">
                  <label for="prioridad" class="form-label">Prioridad</label>
                  <b-form-select id="prioridad" :options="ListaPrioridad" required v-model="item.General.Prioridad"
                    value-field="id" text-field="nombre">
                    <template #first>
                      <b-form-select-option :value="null" disabled>-- Seleccione --</b-form-select-option>
                    </template>
                  </b-form-select>

                  <!-- <select required class="form-control" id="prioridad">
                    <option value="alta">Alta</option>
                    <option value="media">Media</option>
                    <option value="baja">Baja</option>
                  </select> -->
                </div>
              </div>
            </div>
            <div class="row px-5 mt-3">
              <div class="col-md-12">
                <div class="mb-3">
                  <label for="mensaje" class="form-label">Mensaje</label>
                  <textarea required v-model="item.Detail.Mensaje" placeholder="Escriba su mensaje..."
                    class="form-control" id="mensaje" rows="6"></textarea>
                </div>
              </div>
            </div>
            <div class="row px-5 mt-3">

              <div class="col-md-12">
                <label for="mensaje" class="form-label">Cargar Archivo con la información</label>
                <DropFileContenidoTickets @archivoSeleccionado="handleFileUpload"
                  :pathPost="'PersonaTicket/NuevoTicketDetalle/'" :fileTypes="[
                    'application/pdf',
                    'application/msword',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                    'application/vnd.ms-excel',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'application/vnd.ms-powerpoint',
                    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                    'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
                    'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
                    'application/vnd.ms-powerpoint.slideshow.macroEnabled.12',
                    'application/docx',
                    'application/xlsx',
                    'image/jpeg',
                    'image/jpg',
                    'image/png',
                    'image/gif',
                    'image/*',
                    'text/plain',
                    'video/mp4',
                    'video/x-msvideo',
                    'video/x-matroska',
                    'video/quicktime',
                    'video/x-ms-wmv',
                    'video/webm',
                    'video/3gpp',
                    'video/3gpp2',
                  ]" />
              </div>
            </div>
            <div class="text-right px-5 pb-4">
              <button type="submit" class="mx-1 btn px-4 py-2 btn-primary">
                Enviar
              </button>
              <button type="button" @click="regresar" class="mx-1 btn px-4 py-2 btn-secondary">
                Cancelar
              </button>
            </div>
          </card>
        </b-col>
      </b-row>
    </form>
  </b-container>
</template>
<script>
const Swal = require("sweetalert2");
import DropFileContenidoTickets from "@/components/helexium/DropFileContenidoTickets.vue";
import { eventBus } from "../../../main";

export default {
  data() {
    return {
      ListaPrioridad: [
        { id: 1, nombre: "Baja" },
        { id: 2, nombre: "Media" },
        { id: 3, nombre: "Alta" },
      ],
      listaDepartamentos: [],
      usuario: {},
      personaUbicacion: null,
      item: {
        General: {
          Id: null,
          Asunto: null,
          Fecha: null,
          PersonaId: null,
          Estado: 1,
          Prioridad: null,
          EmpresaId: null,
          DepartamentoId: null,
          AreaId: null,
          SucursalId: null,
        },
        Detail: {
          Id: null,
          TicketId: null,
          urlAdjunto: null,
          DeId: null,
          ParaId: null,
          Mensaje: null,
          Fecha: null,
          Leido: false,
        },
      },
      file: null,
      files: null,
      filelist: [],
      file1: null,
      filename1: null,
    };
  },
  components: {
    DropFileContenidoTickets
  },
  async mounted() {
    this.usuario = JSON.parse(localStorage.getItem("setPersonaAct"));
    await this.cargarDepartamentos();
    await this.cargarPersonaUbicacion();
  },
  methods: {
    async cargarPersonaUbicacion() {
      try {
        const res = await this.$store.dispatch("hl_get", {
          path: "PersonaUbicacion/GetByPersona/" + this.usuario.id,
        });
        console.log("PersonaUbicacion:", res);
        if (res?.cargo) {
          this.personaUbicacion = res;
        }
      } catch (error) {
        console.log("Error al cargar persona ubicación:", error);
      }
    },
    async cargarDepartamentos() {
      try {
        const res = await this.$store.dispatch("hl_get", {
          path: "Departamento/ListDepartamento/" + this.usuario.empresa.id,
        });
        if (res && res.length > 0) {
          this.listaDepartamentos = res;
        }
      } catch (error) {
        console.log("Error al cargar departamentos:", error);
      }
    },
    handleFileUpload(file) {
      this.file = file;
      console.log("El archivo recibido es: ", this.file);

      //this.uploadImagenPerfilUrl(file);
    },
    async renameFile(nameFile) {
      this.realName = nameFile;
      let collectionBad = "á é í ó ú Á É Í Ó Ú ñ Ñ";
      let collectionGood = "a e i o u A E I O U n N";
      let collectionBadA = collectionBad.split(" ");
      let collectionGoodA = collectionGood.split(" ");
      let count = 0;
      for await (let it of collectionBadA) {
        let pos = nameFile.indexOf(it);
        if (pos > 0) {
          nameFile = nameFile.replaceAll(it, collectionGoodA[count]);
        }
        pos = 0;
        count++;
      }
      return nameFile;
    },
    async uploadImagenPerfilUrl(ticketId) {
      try {
        this.$isLoading(true);
        console.log("[uploadImagenPerfilUrl]", ticketId);
        //this.file = file; //event.target.files[0];
        this.filename = await this.renameFile(this.file.name); // Math.floor(Math.random() * 9999999999999 + 1);
        // console.log("aaaaaaaaaaaaaaa", this.file, this.filename);
        if (this.filename != null) {
          const resultado = await new Promise((resolve, reject) => {
            eventBus.$emit(
              "GuardandoContenidoCurso",
              { resolve, reject }, // este es el "ack"
              `SoporteTickets/${this.usuario.empresa.nombre.replace(/\s/g, "")}`,
              this.file,
              ticketId
            );

          });

          console.log("Archivo subido con éxito:", resultado);
          return resultado;
        }
        this.$isLoading(false);
        return null;
      } catch (error) {
        this.$isLoading(false);
        console.log("Error al subir archivo:", error);
        return null;
      }
    },

    async saveData() {
      try {
        this.$isLoading(true);

        // Debug: Ver estructura
        console.log("PersonaUbicacion:", this.personaUbicacion);

        this.item.General.PersonaId = this.usuario.id;
        this.item.General.EmpresaId = this.usuario.empresa.id;

        // AreaId desde personaUbicacion (acceder al objeto area.id)
        this.item.General.AreaId =
          this.personaUbicacion?.area?.id ||
          this.personaUbicacion?.AreaId ||
          null;

        // SucursalId desde personaUbicacion (acceder al objeto sucursal.id)
        this.item.General.SucursalId =
          this.personaUbicacion?.sucursal?.id ||
          this.personaUbicacion?.SucursalId ||
          null;

        // DepartamentoId ya está seleccionado en el dropdown (this.item.General.DepartamentoId)

        this.item.General.Fecha = this.$moment
          .tz(new Date(), "America/Bogota")
          .format("YYYY-MM-DDTHH:mm");

        this.item.Detail.DeId = this.usuario.id;
        this.item.Detail.Fecha = this.$moment
          .tz(new Date(), "America/Bogota")
          .format("YYYY-MM-DDTHH:mm");

        console.log("Datos a enviar (General):", this.item.General);
        console.log("DepartamentoId:", this.item.General.DepartamentoId);
        console.log("AreaId:", this.item.General.AreaId);
        console.log("SucursalId:", this.item.General.SucursalId);
        let dataGeneral = await this.$store.dispatch("hl_post", {
          path: "PersonaTicket/NuevoTicketGeneral",
          data: this.item.General,
        });
        if (dataGeneral > 0) {
          let dataCorreo = {
            Correo: "info@helexium.cloud",
            Asunto: "Nuevo ticket: " + this.item.General.Asunto,
            Mensaje: this.item.Detail.Mensaje,
          };
          let resCorreo = await this.$store.dispatch("hl_post", {
            path: "Persona/EnvioNotificacionCorreoCustom",
            data: dataCorreo,
          });

          console.log(resCorreo);
          this.item.Detail.TicketId = dataGeneral;

          // Solo subir archivo si existe
          if (this.file) {
            this.item.Detail.urlAdjunto = await this.uploadImagenPerfilUrl(
              dataGeneral
            );
          } else {
            this.item.Detail.urlAdjunto = null;
          }

          let dataDetalle = await this.$store.dispatch("hl_post", {
            path: "PersonaTicket/NuevoTicketDetalle",
            data: this.item.Detail,
          });

          if (dataGeneral > 0 && dataDetalle > 0) {
            this.$isLoading(false);
            this.$router.push("/helex/Tickets");
            Swal.fire("Listo!", "Ticket creado correctamente!!", "success");
          }
        } else {
          Swal.fire("Error!", "Intentalo nuevamente!!", "error");
        }
        this.$isLoading(false);
      } catch (error) {
        this.$isLoading(false);
        console.log("error", error);
      }
    },
    regresar() {
      this.$router.push("/helex/Tickets");
    },
  },
};
</script>
